// extracted by css-extract-rspack-plugin
export default {"amount":"amount___huwGwoHA","amount__sign":"amount__sign___Mtlhrlzy"};